export default __webpack_public_path__ + "static/mark-72eb880e359c89268e0c94f52dd03ec1.png";